import { Component, input, output } from '@angular/core';

import { IconComponent } from '@program-suite/util-icons';
import { ToolbarTileViewModel, ToolbarTilesViewModel } from '@program-suite/data-common';

@Component({
  selector: 'lib-toolbar',
  imports: [IconComponent],
  templateUrl: './toolbar.component.html',
  styleUrl: './toolbar.component.scss',
})
export class ToolbarComponent {
  layout = input<'row' | 'column'>('row');
  tiles = input<ToolbarTileViewModel[]>([]);
  click = output<ToolbarTileViewModel>();
  
  onClick(tile: ToolbarTileViewModel) {
    this.click.emit(tile);
  }
}
